import React from "react";
import { Link } from "react-router-dom";
import { TOMES } from "./tomeData";
import "./Library.scss";

const ORNAMENTS = ["✦", "◆", "⬡", "✦", "◆", "⬡", "✦"];

const LibraryShelf: React.FC = () => {
    return (
        <div className="library-shelf-wrapper">
            <div className="box-shadow">
                <div className="library-header">
                    <h1 className="library-header-title">Brigobaen Library</h1>
                    <p className="library-header-subtitle">
                        A collection of lore, histories, and arcane knowledge
                        from the world of Oberin
                    </p>
                </div>

                <div
                    className="library-shelf"
                    role="list"
                    aria-label="Available tomes"
                >
                    {TOMES.map((tome, i) => (
                        <Link
                            key={tome.id}
                            to={tome.path}
                            className="library-book"
                            style={{
                                backgroundColor: tome.spineColor,
                                color: tome.spineTextColor,
                            }}
                            role="listitem"
                            aria-label={`${tome.title}${tome.subtitle ? " — " + tome.subtitle : ""}, by ${tome.author}`}
                        >
                            <span
                                className="library-book-ornament"
                                aria-hidden="true"
                            >
                                {ORNAMENTS[i % ORNAMENTS.length]}
                            </span>
                            <span className="library-book-title">
                                {tome.title}
                                {tome.subtitle ? ` · ${tome.subtitle}` : ""}
                            </span>
                            <span
                                className="library-book-ornament"
                                aria-hidden="true"
                            >
                                {ORNAMENTS[i % ORNAMENTS.length]}
                            </span>
                        </Link>
                    ))}
                </div>

                <div className="library-description">
                    Click on a tome to read its contents. These works were
                    gathered and preserved by the scholars and clergy of
                    Brigobaen.
                </div>
            </div>
        </div>
    );
};

export default LibraryShelf;
